import CloseIcon from "@mui/icons-material/Close";
import { Drawer } from "@mui/material";
import cloneDeep from "lodash/cloneDeep";
import React, { useState, useEffect } from "react";
import { useAuthenticated } from "react-admin";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { AmendementShow } from "../amendements";
import { Show } from "../components/show";
import {
	acteurDataset,
	amendementDataset,
	documentDataset,
	dossierDataset,
	interventionDataset,
	organeDataset,
	questionDataset,
	reunionDataset,
	scrutinDataset,
} from "../datasets";
import { MultiList } from "./MultiList";

export const Search = ({ dataset }) => {
	const { id } = useParams();
	const navigate = useNavigate();
	const [isDrawerOpen, setIsDrawerOpen] = useState(Boolean(dataset && id));
	const [searchParams] = useSearchParams();

	const datasets = {
		dossiers: cloneDeep(dossierDataset),
		acteurs: cloneDeep(acteurDataset),
		amendements: {
			...amendementDataset,
			columns: amendementDataset.columns.filter(
				(column) => !["subdivisionRefHash"].includes(column.accessorKey),
			),
			rowRedirect: (item) =>
				`/parliament/amendements/${item.uid}?${searchParams.toString()}`,
		},
		scrutins: cloneDeep(scrutinDataset),
		reunions: cloneDeep(reunionDataset),
		interventions: cloneDeep(interventionDataset),
		documents: cloneDeep(documentDataset),
		questions: cloneDeep(questionDataset),
		organes: cloneDeep(organeDataset),
	};

	useAuthenticated();

	useEffect(() => {
		if (dataset && id) {
			setIsDrawerOpen(true);
		}
	}, [dataset, id]);

	const handleCloseDrawer = () => {
		setIsDrawerOpen(false);
		navigate(`/parliament/amendements?${searchParams.toString()}`);
	};

	return (
		<>
			<MultiList
				initialDataset={dataset}
				datasets={datasets}
				disableSyncWithLocation={false}
				showSearch={true}
				hideListIfEmpty={true}
				height="90vh"
			/>
			<Drawer
				open={isDrawerOpen}
				anchor="right"
				sx={{ zIndex: 100 }}
				onClose={handleCloseDrawer}
			>
				<Show
					resource={dataset}
					includes={[
						"acteurRef.groupeParlementaire",
						"acteurRef.mandatPrincipal",
						"documentRef.dossierRef",
						"gouvernementOrganeRef",
					]}
					backIcon={<CloseIcon />}
					backText={"Fermer"}
					backLink={`/parliament/amendements?${searchParams.toString()}`}
					onClickBackLink={handleCloseDrawer}
				>
					<AmendementShow />
				</Show>
			</Drawer>
		</>
	);
};
